import React from 'react';
import { func, shape, string, object, bool } from 'prop-types';

// Import styled components
import { Wrapper, Description, ButtonsContainer } from './styles';

// Import components
import Preview from 'components/views/vod/components/sliders/Carousel/components/Info/preview/Preview';
import {
	DetailsButton,
	FavouriteButton
} from 'components/views/vod/components/buttons';
import { MoreInfoButton, Title } from 'components/elements';

// Import helpers
import { checkProductSubtype, getPreviewAssetId } from 'helpers';

// Import utilities
import { useProductTranslations } from 'components/utilities';

const BasicInfo = ({ currentItem, kids, startStopCarousel }) => {
	const { uuid, previews, images, subtype, hide_title, context } = currentItem;

	const { isBanner } = checkProductSubtype(subtype);

	const {
		product: { title, short_desc }
	} = useProductTranslations({ data: currentItem });

	const videoID = getPreviewAssetId(previews);

	const url = context?.url_pc;

	return (
		<Wrapper>
			<Title
				title={title}
				images={images}
				subtype={subtype}
				hideTitle={hide_title}
			/>
			<Description>{short_desc}</Description>
			<ButtonsContainer isPreview={videoID}>
				{isBanner ? (
					<MoreInfoButton url={url} />
				) : (
					<>
						<DetailsButton {...currentItem} />
						<FavouriteButton kids={kids} uuid={uuid} />
						{videoID && (
							<Preview
								uuid={uuid}
								videoID={videoID}
								startStopCarousel={startStopCarousel}
							/>
						)}
					</>
				)}
			</ButtonsContainer>
		</Wrapper>
	);
};

BasicInfo.propTypes = {
	startStopCarousel: func.isRequired,
	currentItem: shape({
		uuid: string.isRequired,
		title: string.isRequired,
		short_desc: string.isRequired,
		subtype: string.isRequired,
		previews: object
	}),
	kids: bool.isRequired
};

export default BasicInfo;
